import React, { useState, useContext, useRef, useEffect } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import mylogo from "../../assets/images/letscoolfulllogowhite.png";
import Alertmsg from "../../components/Alertmsg";
import Loader from "../../components/Loader";
import authsService from "../../services/auths.service";
import { AuthContext } from "../../context/Authcontext";
import { Signinclientvalidationschema } from "../../components/Validation";

const Signinclient = () => {
  const userinfo = authsService.userinfo();
  const ref = useRef();
  let navigate = useNavigate();

  const [iserror, setIserror] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [ismessage, setIsmessage] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const { signIn } = useContext(AuthContext);
  const formik = useFormik({
    initialValues: {
      client_email: "",
      client_password: "",
    },
    validationSchema: Signinclientvalidationschema,
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  const signin = () => {
    setIsLoaded(true);
    authsService
      .signinclient(formik.values)
      .then((res) => {
        console.log(res.data);
        if (res.data.result) {
          setIserror(res.data.status);
          setIsLoaded(false);
          setIsmessage(res.data.message);
          localStorage.setItem("isloggedin", true);
          localStorage.setItem("userinfo", JSON.stringify(res.data.result));
          signIn();
        } else {
          setIserror(res.data.status);
          setIsmessage(res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsmessage(err.message);
        setIsLoaded(false);
        setIserror(false);
        localStorage.clear();
      });
  };

  return (
    <div style={{ position: "absolute" }} className="h-100 bg-primary w-100">
      <div className="d-flex flex-column justify-content-center h-100">
        <div className="d-flex flex-fill justify-content-center p-3 pt-5">
          <img
            className=""
            style={{ width: 140, height: 170 }}
            src={mylogo}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = { mylogo };
            }}
            alt="letscool"
          />
        </div>
        <div
          style={{ borderRadius: 30 }}
          className="bg-white p-3 m-4 pt-5 pb-5"
        >
          <div className="row row-cols-1 row-cols-lg-2">
            <div className="col"></div>
            <div className="col">
              <h1 className="">Welcome Back!</h1>
              <p className="description ">Please Sign In to your client account</p>
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  <div className="col-md-12">
                    <label className="form-label me-4" htmlFor="client_email">
                      Email
                    </label>
                    <div className="input-group ">
                      <input
                        className="form-control form-control-lg"
                        id="client_email"
                        type="text"
                        {...formik.getFieldProps("client_email")}
                      />
                    </div>
                    {formik.touched.client_email &&
                    formik.errors.client_email ? (
                      <div className="error">{formik.errors.client_email}</div>
                    ) : null}
                  </div>
                  <div className="col-md-12">
                    <label
                      className="form-label me-4"
                      htmlFor="client_password"
                    >
                      Password
                    </label>
                    <div className="input-group ">
                      <input
                        className="form-control form-control-lg border-end-0"
                        id="client_password"
                        type={showPass ? "text" : "password"}
                        autoComplete="off"
                        {...formik.getFieldProps("client_password")}
                      />
                      <span
                        onClick={() => setShowPass(!showPass)}
                        className="input-group-text bg-white border-start-0"
                      >
                        <i
                          className={showPass ? "fa fa-eye-slash" : "fa fa-eye"}
                        ></i>{" "}
                      </span>
                    </div>
                    {formik.touched.client_password &&
                    formik.errors.client_password ? (
                      <div className="error">
                        {formik.errors.client_password}
                      </div>
                    ) : null}
                  </div>
                  {/* <div className="col-md-12 text-end"><a className='btn btn-link text-decoration-none' onClick={() => navigate('/resetlink')}>Forget Password ?</a></div> */}
                </div>
                {/* <button type="submit" className="btn btn-primary mt-3" >Login</button> */}
              </form>
              <button
                onClick={signin}
                disabled={!(formik.isValid && formik.dirty)}
                className="btn btn-lg d-block w-100 btn-primary mt-3"
              >
                Login
              </button>
              {/*  <div className='mt-3'>
              Don't have an account yet? <button className='btn btn-link text-decoration-none m-0 p-0' onClick={() => navigate('/signup')}>SignUp</button> here.
            </div> */}
              <div className="mt-2">
                {/*  loader and error handler */}
                {iserror === false || iserror === true ? (
                  <Alertmsg alertmsg={ismessage} type={iserror} />
                ) : (
                  <></>
                )}
                {/*  {<Toastmessage ref={ref} type={error} errormsg={ismessage} />} */}
                {isLoaded ? <Loader /> : <></>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signinclient;
